import { AppFooter, AppNavbar } from "../../components";
import { HomeScreen2, HomeScreen3, HomeScreen4, StoryScreen1, StoryScreen2, StoryScreen3, StoryScreen4 } from "../../containers";
import "./Story.css";


const Story = () => {

    return (
        <div className="story">
            <AppNavbar/>
           <StoryScreen1/>
           <StoryScreen2/>
           <StoryScreen3/>
           <HomeScreen2/>
           <AppFooter/>
           {/* <StoryScreen4/> */}
        </div>
    )
};

export default Story;